/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';

import { formatPhoneNumber } from '../../../utils/formater';

const AddressHelper = ({ address, phone }) => {
    const {
        addressLine1,
        addressLine2,
        cityName,
        state,
        zipcode,
        zipCode,
        countryCode,
    } = address;

    const { number: phoneNumber } = phone;
    return (
        <>
            <div>
                {addressLine1}
                {addressLine2 ? `, ${addressLine2}` : ''}
            </div>
            <div>
                {/*
                    ROSS returns `zipCode`, but the `zipcode` will be used
                    when the `is-order-page-using-ross-endpoint` is off
                 */}
                {cityName}, {state}, {zipcode || zipCode}
            </div>
            {countryCode ? <div>{countryCode}</div> : ''}
            {phoneNumber ? <div>{formatPhoneNumber(phoneNumber)}</div> : ''}
        </>
    );
};

AddressHelper.propTypes = {
    address: PropTypes.object.isRequired,
    phone: PropTypes.object.isRequired,
};

export default AddressHelper;
